Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.GroupsValuesMapper
  map: (values) ->
    _.map(values, (value) -> {id: value, name: value})
